import React from "react";
import { Box } from "@material-ui/core";
import ModalBase from "../ModalBase/ModalBase";

export type DefaultLocationModalProps = {
    isOpen: boolean;
    onClose: () => void;
};

export const DefaultLocationModal: React.FC<DefaultLocationModalProps> = ({ isOpen, onClose }) => {
    return (
        <ModalBase
            open={isOpen}
            title={"Default Country"}
            primaryButtonProps={{
				text: "Close",
				onClick: onClose,
			}}
            onClose={onClose}
        >
            <Box>
                {"We were unable to determine your country, so you've been defaulted to Australia!  If this is incorrect, please change it using the location toggle"}
            </Box>
        </ModalBase>
    )
}

export default DefaultLocationModal;